<script>
   /*************************************************************/
   /* Svelte component for calculation of global model          */
   /*************************************************************/

   import { splitregdata } from 'mdatools/models';

   import { Container, ButtonCancel, Button, Range, Select, Spinner } from './controls';
   import { pls_fit, pls_predict } from './wasm/pcvpls';
   import PCV from './wasm/pcv_wasm.js';

   // main properties of the whole app
   export let dataset = null;
   export let model = null;
   export let calres = null;

   // error handling parameetrs
   let status = 'neutral';
   let errMsg = null;

   // model calculation parameters
   let ncomp = 1;
   let center = 'yes';
   let scale = 'no';

   // promise for model calculation method
   let promise;

   // function that fits the model using given parameters
   async function computeModel(data, ncomp, center, scale) {
      promise = PCV()
         .then(Module => {
            const [X, Y] = splitregdata(data);
            status = 'computing';
            model = pls_fit(Module, X, Y, ncomp, center, scale);
            calres = pls_predict(Module, model, X, Y);
            status = 'success';
         })
         .catch(e =>{
            model = null;
            calres = null;
            status = 'error';
            errMsg = e;
         });
   }

   // event handler which triggers the model computation
   function compute(e) {
      computeModel(dataset.values, ncomp, center === 'yes', scale === 'yes');
   }

   // function which resets the state of the component
   function reset() {
      status = 'neutral';
      promise = null;
      errMsg = null;
      model = null;
   }

   // if data file is empty reset status and error messages
   $: if (dataset === null) reset();

   // set initial number of components depending on dataset size and manual limit of A = 20
   $: maxNComp = dataset ? Math.min(dataset.values.nrows - 2, dataset.values.ncols - 1) : null;
   $: ncomp = maxNComp ? Math.min(maxNComp, 20) : null;
</script>

<!-- settings for global model calculation -->
{#if (dataset && !model) && status !== 'computing'}
   <Container label="# of LVs">
      <Range id="ncomp" bind:value={ncomp} min={1} max={maxNComp} step={1} decNum={0} />
   </Container>
   <Container label="Center">
      <Select id="center" bind:value={center} options={["yes", "no"]} />
   </Container>
   <Container label="Scale">
      <Select id="scale" bind:value={scale} options={["yes", "no"]} />
   </Container>
   <Container label=" ">
      <Button on:click={compute}>Create model</Button>
   </Container>
{/if}

{#if promise}

   <!-- calculation is in process -->
   {#await promise}
      <Container>
         <Spinner />
         <p>Computing global model...</p>
      </Container>

   {:then value}
      <!-- status if succeed -->
      {#if model !== null}
      <Container>
         <p>Global model is computed: {model.ncomp} LVs</p>
         <ButtonCancel on:click={reset} />
      </Container>
      {/if}

   {:catch error}
      <!-- error message if failed -->
      <Container status="error">
         <p>{error}</p>
      </Container>
   {/await}

{/if}



<!-- error message -->
{#if status === 'error' || errMsg}
<Container status="error">
   <p>{errMsg}</p>
</Container>
{/if}
